import { Link } from 'react-router-dom';
import styles from './MainNavBar.module.css';
import 'assets/fonts/fonts.css';
import { ProfileMenu } from './ProfileMenu';
import { ThemeSelector } from './ThemeSelector';
import { LanguageSwitcher } from './LanguageSwitcher';

export interface MainNavItem {
  id?: string | number;
  name: string;
  link: string;
}

interface MainNavBarProps {
  logo1?: string;
  logo2?: string;
  logo3?: string;
  logoLink?: any;
  navItems?: MainNavItem[];
  showSearch: boolean;
  showNotifications: boolean;
  logoutLink?: string;
  isCollection: boolean;
  navString?: string;
}

export const MainNavBar = ({
  logo1,
  logo2,
  logo3,
  logoLink,
  navItems,
  isCollection,
  navString,
}: MainNavBarProps) => {
  return (
    <>
      <nav className={`${styles.navi_black_bg} navbar navbar-expand-lg`}>
        <div className="container-fluid">
          <div className="row col-12">
            <div className="col-sm-12 col-md-3 col-lg-2 col-xl-2 col-xxl-2 p-0">
              <a
                className="navbar-brand col-sm-12 col-md-3 col-lg-2 col-xl-2 col-xxl-2 px-3"
                href={logoLink}
              >
                {logo1 && logo2 && logo3 && (
                  <>
                    <span className={`${styles.logoBadge} me-2`}>
                      <img src={logo1} alt="data platform" width="auto" height="28" />
                    </span>
                    <span className={`${styles.logoBadge} me-2`}>
                      <img src={logo2} alt="data platform" width="auto" height="28" />
                    </span>
                    <span className={styles.logoBadge}>
                      <img src={logo3} alt="data platform" width="auto" height="28" />
                    </span>
                  </>
                )}
              </a>
            </div>
            <div className="col-sm-12 col-md-9 col-lg-10 col-xl-10 col-xxl-10 p-0">
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <div className="row col-12 m-0">
                  <div className="col-sm-12 col-md-12 col-lg-4 h-100">
                    <ul className="navbar-nav mb-2 mb-lg-0">
                      {!isCollection && navString && (
                        <li className="nav-item px-2">
                          <div className={`${styles.list_color} nav-link`}>{navString}</div>
                        </li>
                      )}
                      {isCollection &&
                        navItems &&
                        navItems.map((i) => {
                          return (
                            <li className="nav-item pe-5" key={i.link}>
                              <Link
                                className={`${styles.list_color} nav-link`}
                                aria-current="page"
                                to={i.link}
                              >
                                {i.name}
                              </Link>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-8 h-100 m-0 p-0">
                    <div className="row col-12">
                      <div className="col-sm-12 col-md-12 col-lg-5"></div>

                      <div className="col-sm-12 col-md-12 col-lg-7 p-0">
                        <div className="float-end mt-2 mt-sm-2 mt-md-2 mt-lg-0 d-flex align-items-center gap-3">
                          <LanguageSwitcher />
                          <ThemeSelector />
                          <ProfileMenu />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className={`${styles.toggle_color} navbar-toggler-icon`}></span>
          </button>
        </div>
      </nav>
    </>
  );
};
